export enum StorageKeys {
  TOKEN = 't',
  USER_INFO = 'r',
  EXTERNAL_ID = 'e',
  TOKEN_EXPIRATION = 't_expiration',
  SELECTED_ROLE = 'selectedRole',
  SESSION_ID = 'session_id',
}
